/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Nobox {

    import fld = PluginsessionRow.Fields;
    @Serenity.Decorators.registerClass()
    export class PluginsessionGrid extends NoboxEntityGrid<PluginsessionRow, any> {
        protected getColumnsKey() { return PluginsessionColumns.columnsKey; }
        protected getDialogType() { return PluginsessionDialog; }
        protected getIdProperty() { return PluginsessionRow.idProperty; }
        protected getInsertPermission() { return PluginsessionRow.insertPermission; }
        protected getLocalTextPrefix() { return PluginsessionRow.localTextPrefix; }
        protected getService() { return PluginsessionService.baseUrl; }
        constructor(container: JQuery) {
            super(container);
        }
        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            var arrTenant = Administration.TenantRow.getLookup().itemById;


            Q.first(columns, x => x.field == fld.TenantId).format =
                ctx => {
                    var item = arrTenant[ctx.value];
                    if (item != undefined) {
                        return `<a href="javascript:;" class="tenant-link">${item.Nm}</a>`;
                    } else {
                        return `Tenant Deleted`;
                    }
                };
            Q.first(columns, x => x.field == fld.Tool).format = ctx => `<a href="javascript:;" class="tool-link">${ctx.value}</a>`;
            Q.first(columns, x => x.field == fld.Account).format = ctx => `<a href="javascript:;" class="account-link">${Q.isEmptyOrNull(ctx.value) ? "Account Deleted" : ctx.value}</a>`;

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);
            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            if (target.hasClass("tenant-link")) {
                e.preventDefault();

                var dlg = new Administration.TenantDialog();
                dlg.loadByIdAndOpenDialog(item.TenantId);
            } else if (target.hasClass("tool-link")) {
                e.preventDefault();
                var arrChannel = Q.getLookup("Nobox.ChannelKdLookup").items;
                var detail = arrChannel.find(x => x.Nm === item.Tool);
                if (!Q.isEmptyOrNull(detail)) {
                    var dlgCHannel = new Master.ChannelDialog();
                    dlgCHannel.loadByIdAndOpenDialog(detail.Id);
                }
            } else if (target.hasClass("account-link")) {
                e.preventDefault();

                var dlgAcc = new AccountDialog();
                dlgAcc.loadByIdAndOpenDialog(item.AccountId);
            }
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            //request.ColumnSelection = 1;
            return true;
        }
    }
}